module.exports = __webpack_public_path__ + "img/hbh.ac30ac83.png";